module.exports = __webpack_public_path__ + "media/images/Group 12-7c55fe98662e9fae2deed68800c2e922.png";